// EnjoyKids: keep size selection outside the vendor's cart and swatch classes.
if (!customElements.get('product-card-sizes')) {
  customElements.define('product-card-sizes', class extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.card-wrapper');
      this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.sizeIndex = Number(this.dataset.sizePosition) - 1;
      this.buttons = [...this.querySelectorAll('button[data-size]')];
      this.selectedSize = this.querySelector('[aria-pressed="true"]')?.dataset.size;
      this.onClick = event => {
        const button = event.target.closest('button[data-size]');
        if (!button || button.disabled || !this.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        this.selectedSize = button.dataset.size;
        this.syncSelection();
      };
      this.addEventListener('click', this.onClick);
      // Native swatches change their active class on mobile and replace the
      // quick-add button asynchronously on desktop. Preserve the chosen size
      // across both paths, without modifying the upstream swatch lifecycle.
      this.observer = new MutationObserver(() => this.syncSelection());
      const colors = this.card.querySelector('.card__colors');
      if (colors) this.observer.observe(colors, { subtree: true, attributes: true, attributeFilter: ['class'] });
      const actions = this.card.querySelector('.card-information__button');
      if (actions) this.observer.observe(actions, { childList: true, subtree: true });
      this.syncSelection();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
    }

    syncSelection() {
      const referenceId = this.card.querySelector('color-swatch.is-active')?.dataset.variantId || this.dataset.defaultVariantId;
      const reference = this.variants.find(variant => String(variant.id) === referenceId);
      if (!reference) return;
      const matchesSize = (variant, size) => variant.options.every((value, index) =>
        value === (index === this.sizeIndex ? size : reference.options[index]));
      let selected;
      this.buttons.forEach(button => {
        const variant = this.variants.find(candidate => matchesSize(candidate, button.dataset.size));
        const available = Boolean(variant?.available);
        const pressed = button.dataset.size === this.selectedSize;
        button.disabled = !available;
        button.classList.toggle('is-disabled', !available);
        button.classList.toggle('is-selected', pressed);
        button.setAttribute('aria-pressed', String(pressed));
        if (pressed && available) selected = variant;
      });
      const addButton = this.card.querySelector('add-to-cart');
      if (addButton) {
        // An unavailable size/color pair must never silently add another size.
        addButton.dataset.variantId = selected ? String(selected.id) : '';
        addButton.toggleAttribute('disabled', !selected);
        addButton.setAttribute('aria-disabled', String(!selected));
      }
    }
  });
}
